/**
 * Ad-block detection.
 * Checks whether the AdSense library (loaded in the page head) was blocked.
 * Shows a dismissible banner when an ad blocker is detected.
 */
(function() {
    'use strict';

    var STORAGE_KEY = 'adblock-banner-dismissed';
    var DISMISS_DURATION_MS = 7 * 24 * 60 * 60 * 1000;
    var CHECK_DELAY_MS = 2000;

    function isDismissed() {
        try {
            var ts = localStorage.getItem(STORAGE_KEY);
            if (!ts) return false;
            return (Date.now() - parseInt(ts, 10)) < DISMISS_DURATION_MS;
        } catch (_) {
            return false;
        }
    }

    function dismiss() {
        try {
            localStorage.setItem(STORAGE_KEY, String(Date.now()));
        } catch (_) {
            // localStorage unavailable
        }
        var banner = document.getElementById('adblockBanner');
        if (banner) banner.remove();
    }

    function showBanner() {
        var banner = document.getElementById('adblockBanner');
        if (banner) {
            banner.classList.remove('hidden');
        }
    }

    function detect() {
        if (!document.getElementById('adblockBanner')) return;
        if (isDismissed()) return;

        // Only check if AdSense was actually included on the page.
        // Without this guard, environments where ads aren't served (local dev,
        // ad-free tiers) would falsely trigger the ad-block banner.
        var adsenseScript = document.querySelector('script[src*="pagead2.googlesyndication.com"]');
        if (!adsenseScript) return;

        // AdSense is loaded via <script async> in the page head.
        // If an ad blocker prevented it, window.adsbygoogle won't exist.
        setTimeout(function() {
            if (typeof window.adsbygoogle === 'undefined') {
                showBanner();
            }
        }, CHECK_DELAY_MS);
    }

    window.__adblockDismiss = dismiss;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', detect);
    } else {
        detect();
    }
})();
